if ('scrollBehavior' in document.documentElement.style === false) {
  import(/* webpackChunkName: "smooth-scroll" */ 'smoothscroll-polyfill').then(
    ({ default: smoothscroll }) => {
      smoothscroll.polyfill()
    }
  )
}

function getHeaderHeight() {
  const wrapper = document.querySelector('.header__body')
  if (wrapper) {
    return wrapper.getBoundingClientRect().height
  }
  return 0
}

/**
 *
 * @param {HTMLElement} element
 */
export function scrollTo(element, isOffset) {
  const offset = getHeaderHeight()
  window.scroll({
    top:
      document.documentElement.scrollTop +
      element.getBoundingClientRect().top -
      (isOffset ? 24 : 0) -
      offset,
    behavior: 'smooth'
  })
}
